import DeltaCell from "./DeltaCell.vue";
import Expandable from "./Expandable.vue";
import GroupingCell from "./GroupingCell.vue";

export const CELL_RENDERS = {
  delta: DeltaCell,
  expandable: Expandable,
  grouping: GroupingCell,
};
